"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// 品牌弹窗组件
var react_1 = __importStar(require("react"));
var request_1 = require("../../utils/request");
var tools_1 = require("../../utils/tools");
var dataStorage_1 = require("../../utils/dataStorage");
var lazyloadImg_1 = require("../../utils/lazyloadImg");
var WithErrorHandler_1 = require("../WithErrorHandler");
var lazyloadObj = null;
var BrandPop = /** @class */ (function (_super) {
    __extends(BrandPop, _super);
    function BrandPop(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: -1,
            uId: tools_1.getCookie('58tj_uuid'),
            brands: {},
            letters: [],
            curLetter: 'hotBrands',
            isShowLetterPop: false,
        };
        _this.findStart = _this.findStart.bind(_this);
        _this.wrapScroll = _this.wrapScroll.bind(_this);
        _this.closePop = _this.closePop.bind(_this);
        return _this;
    }
    BrandPop.prototype.componentDidMount = function () {
        var that = this;
        lazyloadObj = new lazyloadImg_1.lazyloadImg({
            eleName: '#brandsPop img',
            data_attribute: '_src',
            preloadHeight: 'screen',
            scrollWrap: '#brandList',
        });
        // that.getBrandData();
    };
    // ()componentWillReceiveProps
    BrandPop.prototype.componentDidUpdate = function () {
        // console.log('componentDidUpdate')
        if (this.props.show && JSON.stringify(this.state.brands) == '{}') {
            // console.log('+++++start+++++')
            this.getBrandData();
        }
        return true;
    };
    BrandPop.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var that = this;
        var _a = this.state, selected = _a.selected, letters = _a.letters, brands = _a.brands, curLetter = _a.curLetter, isShowLetterPop = _a.isShowLetterPop, show = this.props.show, dom = that.refs.brands;
        if (nextState.selected == selected &&
            JSON.stringify(nextState.letters) == JSON.stringify(letters) &&
            JSON.stringify(nextState.brands) == JSON.stringify(brands) &&
            nextState.curLetter == curLetter &&
            nextState.isShowLetterPop == isShowLetterPop &&
            nextProps.show == show) {
            return false;
        }
        else {
            if (nextProps.show != show) {
                dom.scrollTop = 0;
            }
            return true;
        }
    };
    BrandPop.prototype.render = function () {
        var _this = this;
        var _a = this.state, _b = _a.brands, hotBrand = _b.hotBrand, letterRank = _b.letterRank, letters = _a.letters, curLetter = _a.curLetter, isShowLetterPop = _a.isShowLetterPop;
        var _c = this.props, pageType = _c.pageType, show = _c.show;
        return (react_1.default.createElement("div", { className: "newcar_ui_brandsPopWrap " + (show ? '' : 'hide'), ref: 'brandsPopWrap', id: 'brandsPop' },
            react_1.default.createElement("p", { className: 'newcar_ui_brandPopTitle' },
                react_1.default.createElement("b", null, "\u54C1\u724C"),
                react_1.default.createElement("a", { className: 'newcar_ui_brandPopCloseBtn', onClick: this.closePop })),
            react_1.default.createElement("div", { className: 'newcar_ui_brands', ref: 'brands', id: 'brandList', onScroll: this.wrapScroll },
                hotBrand && hotBrand.length > 0 ? (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement("p", { className: 'newcar_ui_brandListTitle', ref: 'hotBrands' }, "\u70ED\u95E8\u54C1\u724C"),
                    react_1.default.createElement("div", { className: 'newcar_ui_hotBrands clearfix' }, hotBrand.map(function (item) { return (react_1.default.createElement("a", { key: "hotBrand_" + item.brandId, "data-pagetype": pageType, "data-actiontype": "pinpaixuanze", "data-params": item.brandId, onClick: function () { return _this.selectBrand(item); } },
                        react_1.default.createElement("img", { src: '//imgm.xgo-img.com.cn/7_module_images/120x90/58b6992001d5a.jpg', 
                            // @ts-ignore
                            _src: item.logoImg, className: 'newcar_ui_brandImg' }),
                        react_1.default.createElement("b", null, item.brandName))); })))) : (''),
                typeof this.props.showSelectAll === 'boolean' &&
                    this.props.showSelectAll && (react_1.default.createElement("dl", { className: 'newcar_ui_brandList', ref: 'all', key: "letter_all" },
                    react_1.default.createElement("dd", { key: "brand_all" },
                        react_1.default.createElement("a", { "data-pagetype": pageType, "data-actiontype": "pinpaixuanze", "data-params": 0, onClick: function () {
                                return _this.selectBrand({
                                    brandId: 0,
                                    // @ts-ignore
                                    brandName: '',
                                });
                            } },
                            react_1.default.createElement("b", null, "\u4E0D\u9650\u54C1\u724C"))))),
                letterRank ? (react_1.default.createElement(react_1.Fragment, null, Object.keys(letterRank).map(function (keyName) { return (react_1.default.createElement("dl", { className: 'newcar_ui_brandList', ref: keyName, key: "letter_" + keyName },
                    react_1.default.createElement("dt", null, keyName),
                    letterRank[keyName].map(function (item) { return (react_1.default.createElement("dd", { key: "brand_" + item.brandId },
                        react_1.default.createElement("a", { "data-pagetype": pageType, "data-actiontype": "pinpaixuanze", "data-params": item.brandId, onClick: function () { return _this.selectBrand(item); } },
                            react_1.default.createElement("img", { src: '//imgm.xgo-img.com.cn/7_module_images/120x90/58b6992001d5a.jpg', 
                                // @ts-ignore
                                _src: item.logoImg, className: 'newcar_ui_brandImg' }),
                            react_1.default.createElement("b", null, item.brandName)))); }))); }))) : ('')),
            letters && letters.length > 0 ? (react_1.default.createElement("div", { id: 'brandNav', className: 'newcar_ui_brandNav', ref: 'brandNav', onTouchMove: this.findStart, 
                // onTouchStart={this.findStart}
                onTouchEnd: this.findStart, onTouchCancel: this.findStart }, letters.map(function (item) { return (react_1.default.createElement("a", { className: item.con == curLetter ? 'cur' : '', "data-con": item.con, key: "lettername_" + item.title }, item.title)); }))) : (''),
            react_1.default.createElement("div", { className: "newcar_ui_bigLetter " + (isShowLetterPop ? '' : 'hide') }, curLetter == 'hotBrands' ? '热' : curLetter)));
    };
    BrandPop.prototype.getBrandData = function () {
        // 获取品牌数据
        var that = this, uId = that.state.uId, _a = that.props, ajaxUrl = _a.ajaxUrl, saveKey = _a.saveKey;
        // ajaxDomain=getDomainName(),
        // ajaxUrl=`//service${ajaxDomain}.58che.com/apps/v1/info/?businessId=2`;
        // console.log('----huoqu shuju----- ',ajaxUrl)
        dataStorage_1.getStorageData(saveKey).then(function (data) {
            // 本地有品牌数据
            // console.log('getStorageData',data)
            that.setBrandData(data);
        }, function (error) {
            // 本地没有品牌数据 异步获取数据
            ajaxUrl &&
                request_1.request(ajaxUrl, { uId: uId }, 'jsonp')
                    .then(function (response) {
                    // console.log('getBrandAjax',response)
                    if (response.code == 0) {
                        var data = response.entity.data.infoList;
                        dataStorage_1.setStorageData({ key: saveKey, value: data, expire: 10 });
                        that.setBrandData(data);
                    }
                    else {
                        console.log(response.message);
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                });
        });
    };
    BrandPop.prototype.setBrandData = function (data) {
        // 设置品牌数据
        var that = this, letters = [];
        if (data.hotBrand && data.hotBrand.length > 0) {
            letters.push({ title: '热', con: 'hotBrands' });
        }
        Object.keys(data.letterRank).map(function (keyName) {
            letters.push({ title: keyName, con: keyName });
        });
        that.setState({
            brands: data,
            letters: letters,
        }, function () {
            lazyloadObj.addDom('#brandList');
        });
    };
    BrandPop.prototype.findStart = function (ev) {
        // 侧导航滑动执行事件
        var that = this, e = tools_1.getEvent(ev), point = e.changedTouches ? e.changedTouches[0] : e, group = '', pointElement = document.elementFromPoint(point.clientX, point.clientY), top = 0;
        if (pointElement) {
            group = pointElement.innerText;
            if (group && group.length == 1) {
                if (group == '热') {
                    group = 'hotBrands';
                }
                var groupDom = that.refs[group], brandsDom = that.refs.brands;
                top = groupDom.offsetTop;
                brandsDom.scrollTop = top;
                that.showLetterPop(group);
            }
        }
    };
    BrandPop.prototype.wrapScroll = function (event) {
        // 滚动品牌弹窗定位相应字母
        var that = this, _a = this.state, letters = _a.letters, curLetter = _a.curLetter, top = tools_1.getTarget(event).scrollTop, str = '', dom, dom2;
        for (var i = 0; i < letters.length; i++) {
            if (typeof letters[i + 1] == 'undefined') {
                return false;
            }
            str = letters[i].con;
            dom = that.refs[str];
            dom2 = that.refs[letters[i + 1].con];
            if (dom.offsetTop <= top &&
                (i == letters.length - 1 || dom2.offsetTop - 50 > top) &&
                str != curLetter) {
                // that.showLetterPop(str);
                that.setState({
                    curLetter: str,
                });
                return false;
            }
        }
    };
    BrandPop.prototype.showLetterPop = function (str) {
        // 显示字母弹窗
        var that = this;
        that.setState({
            curLetter: str,
            isShowLetterPop: true,
        });
        window.setTimeout(function () {
            that.setState({
                isShowLetterPop: false,
            });
        }, 500);
    };
    BrandPop.prototype.closePop = function () {
        var closeFun = this.props.closeFun;
        closeFun && closeFun();
    };
    BrandPop.prototype.selectBrand = function (obj) {
        var _a = this.props, callbackFun = _a.callbackFun, selected = _a.selected, closeFun = _a.closeFun, pageType = _a.pageType, forcedCallback = _a.forcedCallback;
        if (obj.brandId !== selected || forcedCallback) {
            this.setState({
                selected: obj.brandId,
            });
            callbackFun && callbackFun(obj);
        }
        else {
            closeFun && closeFun();
        }
    };
    return BrandPop;
}(react_1.Component));
var ajaxDomain = typeof window === 'undefined' ? '' : tools_1.getDomainName();
// @ts-ignore
BrandPop.defaultProps = {
    ajaxUrl: "//service" + ajaxDomain + ".58che.com/apps/v1/info/?businessId=2",
    forcedCallback: false,
    pageType: '',
    selected: '',
    saveKey: 'brandList',
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
    showSelectAll: false,
    // eslint-disable-next-line no-empty-function
    callbackFun: function (obj) { },
};
exports.default = WithErrorHandler_1.WithErrorHandler(BrandPop);
